/**
 * State used in rendering InteractionTagSecondary
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
